/* Fann Bliss: bundles section runtime (sections/fann-bundles.liquid).
   - Bundle shelf: turns the pricing rules (the same JSON that mirrors the Shopify automatic discounts) into picture cards.
   - Quick picker: a sheet with one slot per piece; designs load from the store through the fann-picker-feed section.
   - Countries builder: choose a bundle, pick countries, see the shelf and the price, add everything in one tap.
   - Product page (sections/fann-pdp-bundles.liquid): the same shelf narrowed to the product's family, with the product
     standing in its own slot and already picked in the quick picker, plus the buy-box savings strip
     (snippets/fann-pdp-offer.liquid).
   Pricing and cart helpers come from fann-home.js (window.FannHome). */
(function () {
  'use strict';
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var FH = function () { return window.FannHome || {}; };
  var reduce = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;

  var ICON = {
    mug: '<path d="M5 8h11v7a4 4 0 0 1-4 4H9a4 4 0 0 1-4-4z"/><path d="M16 10h2a2.5 2.5 0 0 1 0 5h-2"/><path d="M8 4c0 1.5 1 1.5 1 3M12 4c0 1.5 1 1.5 1 3"/>',
    tumbler: '<path d="M6 5h12l-1.5 15h-9z"/><path d="M5 5h14M13 2l2 3"/>',
    bottle: '<path d="M10 3h4v3l2 3v10a2 2 0 0 1-2 2h-4a2 2 0 0 1-2-2V9l2-3z"/><path d="M8 13h8"/>',
    magsafe: '<path d="M6 4v8a6 6 0 0 0 12 0V4"/><path d="M6 4h4v8a2 2 0 0 0 4 0V4h4"/><path d="M6 8h4M14 8h4"/>',
    coaster: '<circle cx="12" cy="12" r="8"/><circle cx="12" cy="12" r="3"/>',
    x: '<path d="M6 6l12 12M18 6 6 18"/>',
    check: '<path d="m5 12 4.5 4.5L19 7"/>',
    plus: '<path d="M12 5v14M5 12h14"/>',
    arrow: '<path d="M5 12h14M13 6l6 6-6 6"/>'
  };
  function icon(k) { return '<svg class="fh-ic" viewBox="0 0 24 24" aria-hidden="true" focusable="false">' + (ICON[k] || ICON.mug) + '</svg>'; }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function money(cents) { var f = FH().money; return f ? f(Math.round(cents)) : 'AED ' + (cents / 100 % 1 ? (cents / 100).toFixed(2) : cents / 100); }
  function cents(aed) { return Math.round((parseFloat(aed) || 0) * 100); }
  function fill(t, map) { return String(t || '').replace(/\[(\w+)\]/g, function (m, k) { return map[k] != null ? map[k] : m; }); }
  /* lower-case a label for use mid-sentence, keeping brand words like MagSafe as they are */
  function lc(t) { return String(t || '').split(' ').map(function (w) { return /[A-Z]/.test(w.slice(1)) ? w : w.toLowerCase(); }).join(' '); }
  function parse(el, fb) { try { return JSON.parse((el && el.textContent) || ''); } catch (e) { return fb; } }
  function best(items) {
    var P = FH().pricing;
    if (P && P.best) return P.best(items);
    var list = items.reduce(function (a, b) { return a + (b.p || 0); }, 0);
    return { list: list, save: 0, total: list, rule: null, kind: '' };
  }
  /* pair names always read in the same order (mug, tumbler, bottle, MagSafe, coaster), on every page */
  function pairTitle(ctx, a, b) { return FAMS.indexOf(a) <= FAMS.indexOf(b) ? ctx.one(a) + ' + ' + ctx.one(b) : ctx.one(b) + ' + ' + ctx.one(a); }
  /* "Any 2 mugs or coasters + 1 tumbler or bottle" */
  function setSub(ctx, q, b, g) {
    var orw = ctx.W.or || 'or';
    return fill(ctx.W.setSub || 'Any [q] [buy] + 1 [get]', { q: q, buy: listWords(b.map(function (x) { return lc(ctx.many(x)); }), orw), get: listWords(g.map(function (x) { return lc(ctx.one(x)); }), orw) });
  }
  function listWords(a, orw) { return a.length > 1 ? a.slice(0, -1).join(', ') + ' ' + orw + ' ' + a[a.length - 1] : (a[0] || ''); }
  /* true heights in cm, used to stand pieces at their real relative size. Card pieces are not lazy: before it loads an
     img sized by height alone is 0px wide, and some browsers never start a lazy load for it. */
  var CM = { mug: 9.5, coaster: 10, tumbler: 17.5, bottle: 22, magsafe: 28 };
  var TINT = { mug: 't-pink', tumbler: 't-teal', bottle: 't-blue', magsafe: 't-violet', coaster: 't-leaf' };
  var FAMS = ['mug', 'tumbler', 'bottle', 'magsafe', 'coaster'];

  /* ================================================================== section */
  function init(sec) {
    if (!sec || sec.__fbInit) return; sec.__fbInit = true;
    var ctx = {
      sec: sec,
      conf: parse($('script[data-fb-conf]', sec), { fams: {}, words: {} }),
      R: parse($('script[data-fh-rules]', sec), {}),
      F: {}
    };
    try { ctx.F = JSON.parse(sec.getAttribute('data-fh-fams') || '{}'); } catch (e) {}
    ctx.W = ctx.conf.words || {};
    ctx.R.ref = ctx.R.ref || {}; ctx.R.ladders = ctx.R.ladders || []; ctx.R.pairs = ctx.R.pairs || []; ctx.R.sets = ctx.R.sets || [];
    ctx.one = function (f) { return ctx.F['one_' + f] || ctx.F[f] || f; };
    ctx.many = function (f) { return ctx.F[f] || f; };
    ctx.P = parse($('script[data-fb-product]', sec), null);
    ctx.sheet = initSheet(ctx);
    initShelf(ctx);
    initCountries(ctx);
    initOffer(ctx);
  }

  /* ================================================================== shelf */
  function pics(ctx, f) { var fm = ctx.conf.fams && ctx.conf.fams[f]; return (fm && fm.pics || []).filter(Boolean); }
  function stage(ctx, pieces) {
    var max = 0; pieces.forEach(function (p) { max = Math.max(max, CM[p.f] || 12); });
    var tier = max < 15 ? 0.72 : max < 21 ? 0.9 : 1;
    return pieces.map(function (p) {
      var k = ((CM[p.f] || 12) / max * tier).toFixed(3), list = pics(ctx, p.f), src = list[p.n % Math.max(1, list.length)];
      if (p.own && ctx.P && ctx.P.i) {
        /* this product: its own photo, cut out in the browser when it has a white ground */
        return '<span class="fh-photo fb-own' + (ctx.P.k ? ' fh-cutout"' : '" data-fh-src="' + esc(ctx.P.i) + '"') + ' style="--k:' + k + ';--ar:' + (parseFloat(ctx.P.a) || 1) + '"><img src="' + esc(ctx.P.i) + '" alt="" decoding="async" fetchpriority="low"></span>';
      }
      return src ? '<img src="' + esc(src) + '" alt="" decoding="async" fetchpriority="low" style="--k:' + k + '">' : '<span class="fb-ph" style="--k:' + k + '">' + icon(p.f) + '</span>';
    }).join('');
  }
  /* product page: only the rules this product's family takes part in; the product fills the first slot of every card
     and is priced at its own price, the other pieces at the standard price of their kind */
  function buildProductCards(ctx) {
    var R = ctx.R, ref = R.ref, W = ctx.W, P = ctx.P, f = P.f, out = { pairs: [], sets: [], ladders: [] };
    if (!ref[f]) return out;
    var own = { f: f, n: 0, own: true }, pp = P.p || cents(ref[f]);
    R.pairs.forEach(function (p) {
      if (!ref[p.buy] || !ref[p.get] || (p.buy !== f && p.get !== f) || p.buy === p.get) return;
      var other = p.buy === f ? p.get : p.buy, getP = p.get === f ? pp : cents(ref[p.get]);
      var list = pp + cents(ref[other]), save = Math.min(cents(p.off), getP);
      out.pairs.push({ title: pairTitle(ctx, f, other), sub: fill(W.withAny || 'This design + any [fam]', { fam: lc(ctx.one(other)) }), tint: TINT[p.get], pieces: [own, { f: other, n: 0 }], list: list, price: list - save, save: save, slots: [{ fams: [f], own: true }, { fams: [other] }], partner: other });
    });
    R.sets.forEach(function (S) {
      var b = (S.buy || []).filter(function (x) { return ref[x]; }), g = (S.get || []).filter(function (x) { return ref[x]; }), q = S.qty || 2;
      if (!b.length || !g.length) return;
      var inBuy = b.indexOf(f) > -1, inGet = g.indexOf(f) > -1;
      if (!inBuy && !inGet) return;
      var others = b.filter(function (x) { return x !== f; }), pieces = [own], slots = [{ fams: [f], own: true }], list = pp, save, i, x;
      if (inBuy) {
        for (i = 1; i < q; i++) { x = others.length ? others[(i - 1) % others.length] : f; pieces.push({ f: x, n: i }); list += cents(ref[x]); slots.push({ fams: b.slice(), fam: x }); }
        pieces.push({ f: g[0], n: 0 }); list += cents(ref[g[0]]); slots.push({ fams: g.slice(), fam: g[0] });
        save = Math.min(cents(S.off), cents(ref[g[0]]));
      } else {
        for (i = 0; i < q; i++) { x = b[i % b.length]; pieces.push({ f: x, n: i }); list += cents(ref[x]); slots.push({ fams: b.slice(), fam: x }); }
        save = Math.min(cents(S.off), pp);
      }
      out.sets.push({ title: S.name || ctx.F.set || 'Set', sub: setSub(ctx, q, b, g), tint: TINT[g[0]], pieces: pieces, list: list, price: list - save, save: save, slots: slots });
    });
    /* the buy box already shows this product's own quantity prices (snippets/fann-pdp-offer.liquid), so the shelf below
       only carries the pairs and sets; set data-fb-ladders on the section to show the quantity card here as well */
    var steps = !ctx.sec.hasAttribute('data-fb-ladders') ? [] : R.ladders.filter(function (L) { return L.fam === f; }).sort(function (a, c) { return a.min - c.min; });
    if (steps.length) {
      var top = steps[steps.length - 1];
      out.ladders.push({
        ladder: f, title: ctx.many(f), tint: TINT[f], pieces: [own, { f: f, n: 1 }, { f: f, n: 2 }],
        steps: steps.map(function (L) { return fill(W.ladderStep || '[min]+ · [amount] off each', { min: L.min, amount: money(cents(L.off)) }); }),
        list: pp, price: pp - cents(top.off), save: cents(top.off), each: true, min: steps[0].min,
        slots: Array.apply(null, Array(steps[0].min)).map(function (_, j) { return j ? { fams: [f] } : { fams: [f], own: true }; })
      });
    }
    return out;
  }
  function buildCards(ctx) {
    if (ctx.P) return buildProductCards(ctx);
    var R = ctx.R, ref = R.ref, W = ctx.W, out = { pairs: [], sets: [], ladders: [] };
    R.pairs.forEach(function (p) {
      if (!ref[p.buy] || !ref[p.get]) return;
      var list = cents(ref[p.buy]) + cents(ref[p.get]), save = Math.min(cents(p.off), cents(ref[p.get]));
      var a = FAMS.indexOf(p.buy) <= FAMS.indexOf(p.get) ? p.buy : p.get, z = a === p.buy ? p.get : p.buy;
      out.pairs.push({ title: pairTitle(ctx, p.buy, p.get), sub: W.any || 'Any designs', tint: TINT[z], pieces: [{ f: a, n: 0 }, { f: z, n: 0 }], ord: FAMS.indexOf(a) * 10 + FAMS.indexOf(z), list: list, price: list - save, save: save, slots: [{ fams: [p.buy] }, { fams: [p.get] }] });
    });
    R.sets.forEach(function (S) {
      var b = (S.buy || []).filter(function (f) { return ref[f]; }), g = (S.get || []).filter(function (f) { return ref[f]; }), q = S.qty || 2;
      if (!b.length || !g.length) return;
      var pieces = [], slots = [], list = 0;
      for (var i = 0; i < q; i++) { var f = b[i % b.length]; pieces.push({ f: f, n: i }); list += cents(ref[f]); slots.push({ fams: b.slice(), fam: f }); }
      pieces.push({ f: g[0], n: 0 }); list += cents(ref[g[0]]); slots.push({ fams: g.slice(), fam: g[0] });
      var save = Math.min(cents(S.off), cents(ref[g[0]]));
      out.sets.push({ title: S.name || ctx.F.set || 'Set', sub: setSub(ctx, q, b, g), tint: TINT[g[0]], pieces: pieces, list: list, price: list - save, save: save, slots: slots });
    });
    FAMS.forEach(function (f) {
      if (!ref[f]) return;
      var steps = R.ladders.filter(function (L) { return L.fam === f; }).sort(function (a, c) { return a.min - c.min; });
      if (!steps.length) return;
      var top = steps[steps.length - 1], unit = cents(ref[f]);
      out.ladders.push({
        ladder: f, title: ctx.many(f), tint: TINT[f], pieces: [{ f: f, n: 0 }, { f: f, n: 1 }, { f: f, n: 2 }],
        steps: steps.map(function (L) { return fill(W.ladderStep || '[min]+ · [amount] off each', { min: L.min, amount: money(cents(L.off)) }); }),
        list: unit, price: unit - cents(top.off), save: cents(top.off), each: true, min: steps[0].min,
        slots: Array.apply(null, Array(steps[0].min)).map(function () { return { fams: [f] }; })
      });
    });
    out.pairs.sort(function (x, y) { return (x.ord || 0) - (y.ord || 0); });
    return out;
  }
  /* Before the exact pieces are chosen a card shows only what the rule saves: sizes change the price, the saving does
     not. The price you pay appears in the quick picker, on the product page and in the bag, where the pieces are known. */
  function cardHTML(ctx, c, i, tab) {
    var W = ctx.W, btn = c.ladder ? fill(W.pickFam || 'Pick your [fam]', { fam: lc(ctx.many(c.ladder)) }) : c.partner ? fill(W.pickFam || 'Pick your [fam]', { fam: lc(ctx.one(c.partner)) }) : (W.pick || 'Pick designs');
    var saveTxt = c.each ? fill(W.saveUpTo || 'Save up to [amount] each', { amount: money(c.save) }) : (W.save || 'Save') + ' ' + money(c.save);
    return '<article class="fb-card fh-' + c.tint + '">' +
      '<div class="fb-card-stage">' + stage(ctx, c.pieces) + '<span class="fb-save">' + esc(saveTxt) + '</span></div>' +
      '<div class="fb-card-body"><h4>' + esc(c.title) + '</h4>' +
      (c.steps ? '<ul class="fb-steps">' + c.steps.map(function (s) { return '<li>' + esc(s) + '</li>'; }).join('') + '</ul>' : '<p class="fb-card-sub">' + esc(c.sub) + '</p>') +
      '<button type="button" class="fh-btn fh-btn-ink fb-open" data-fb-open="' + tab + ':' + i + '">' + esc(btn) + icon('arrow') + '</button>' +
      '</div></article>';
  }
  /* the pairs: one rule, so one compact list (two different pieces, any designs) rather than a card per pair */
  function pairsHTML(ctx, list) {
    var W = ctx.W;
    return '<ul class="fb-pairs">' + list.map(function (c, i) {
      return '<li><button type="button" class="fb-pair fh-' + c.tint + '" data-fb-open="pairs:' + i + '">' +
        '<span class="fb-pair-art" aria-hidden="true">' + stage(ctx, c.pieces) + '</span>' +
        '<span class="fb-pair-t"><b>' + esc(c.title) + '</b><small>' + esc(c.sub) + '</small></span>' +
        '<span class="fb-pair-s">' + esc((W.save || 'Save') + ' ' + money(c.save)) + '</span>' + icon('arrow') + '</button></li>';
    }).join('') + '</ul>';
  }
  function initShelf(ctx) {
    var shelf = $('[data-fb-shelf]', ctx.sec); if (!shelf) return;
    var cards = buildCards(ctx);
    ctx.cards = cards;
    ['pairs', 'sets', 'ladders'].forEach(function (tab) {
      var list = cards[tab], wrap = $('[data-fb-panel="' + tab + '"] [data-fb-cards]', shelf), tb = $('[data-fb-tab="' + tab + '"]', shelf);
      if (wrap) {
        if (tab === 'pairs') { wrap.classList.add('fb-cards--list'); wrap.innerHTML = pairsHTML(ctx, list); }
        else wrap.innerHTML = list.map(function (c, i) { return cardHTML(ctx, c, i, tab); }).join('');
      }
      if (tb) tb.hidden = !list.length;
    });
    var tabs = $$('[role="tab"]', shelf).filter(function (t) { return !t.hidden; });
    function select(t, focus) {
      tabs.forEach(function (x) { var on = x === t; x.setAttribute('aria-selected', on ? 'true' : 'false'); x.tabIndex = on ? 0 : -1; var p = document.getElementById(x.getAttribute('aria-controls')); if (p) p.hidden = !on; });
      if (focus) t.focus();
    }
    tabs.forEach(function (t, i) {
      t.addEventListener('click', function () { select(t); });
      t.addEventListener('keydown', function (e) {
        var d = e.key === 'ArrowRight' ? 1 : e.key === 'ArrowLeft' ? -1 : 0; if (!d) return;
        e.preventDefault(); select(tabs[(i + d + tabs.length) % tabs.length], true);
      });
    });
    if (tabs[0]) select(tabs[0]);
    shelf.addEventListener('click', function (e) {
      var b = e.target.closest('[data-fb-open]'); if (!b) return;
      var k = b.getAttribute('data-fb-open').split(':'), c = cards[k[0]] && cards[k[0]][+k[1]];
      if (c && ctx.sheet) ctx.sheet.open(c, b);
    });
  }

  /* ================================================================== quick picker */
  var feeds = {};
  function feedUrl(path, params) { var q = Object.keys(params).map(function (k) { return encodeURIComponent(k) + '=' + encodeURIComponent(params[k]); }).join('&'); return path + (path.indexOf('?') > -1 ? '&' : '?') + q; }
  function getFeed(url) {
    if (feeds[url]) return feeds[url];
    feeds[url] = fetch(url, { credentials: 'same-origin', headers: { 'Accept': 'text/html' } }).then(function (r) {
      if (!r.ok) throw new Error('HTTP ' + r.status);
      return r.text();
    }).then(function (html) {
      var m = html.match(/<script[^>]*data-fb-feed[^>]*>([\s\S]*?)<\/script>/);
      if (!m) throw new Error('no feed');
      return JSON.parse(m[1]);
    });
    feeds[url].catch(function () { delete feeds[url]; });
    return feeds[url];
  }
  function initSheet(ctx) {
    var dlg = $('[data-fb-sheet]', ctx.sec); if (!dlg) return null;
    var W = ctx.W, fams = ctx.conf.fams || {};
    var el = {
      title: $('[data-fb-s-title]', dlg), sub: $('[data-fb-s-sub]', dlg), slots: $('[data-fb-slots]', dlg), variant: $('[data-fb-variant]', dlg),
      fams: $('[data-fb-fams]', dlg), q: $('[data-fb-s-q]', dlg), body: $('[data-fb-s-body]', dlg), grid: $('[data-fb-grid]', dlg), msg: $('[data-fb-msg]', dlg),
      more: $('[data-fb-more]', dlg), total: $('[data-fb-s-total]', dlg), was: $('[data-fb-s-was]', dlg), save: $('[data-fb-s-save]', dlg), nudge: $('[data-fb-s-nudge]', dlg), add: $('[data-fb-s-add]', dlg)
    };
    el.q.placeholder = W.search || 'Search designs';
    el.more.textContent = W.more || 'Show more designs';
    var st = null, opener = null, items = [], cat = {}, qTimer = null, seq = 0, lastFam = null;
    if (!window.HTMLDialogElement || !dlg.showModal) { dlg.setAttribute('hidden', ''); }

    function slotFam(s) { return s.fam || s.fams[0]; }
    function catalog(f) { return cat[f] = cat[f] || { items: [], page: 0, pages: 1, busy: false, err: false }; }
    function typeOk(f, it) { var t = fams[f] && fams[f].type; return !t || !it.ty || it.ty === t; }
    function loadPage(f) {
      var c = catalog(f), coll = fams[f] && fams[f].coll;
      if (c.busy || c.page >= c.pages || !coll) return Promise.resolve(c);
      c.busy = true; c.err = false;
      return getFeed(feedUrl('/collections/' + coll, { section_id: 'fann-picker-feed', sort_by: 'best-selling', page: c.page + 1 })).then(function (d) {
        c.page = d.page || c.page + 1; c.pages = d.pages || 1; c.busy = false;
        (d.items || []).forEach(function (it) { if (typeOk(f, it)) c.items.push(it); });
        return c;
      }, function () { c.busy = false; c.err = true; return c; });
    }
    function search(f, q) {
      return getFeed(feedUrl('/search', { q: q, type: 'product', 'options[prefix]': 'last', section_id: 'fann-picker-feed' })).then(function (d) {
        var coll = fams[f] && fams[f].coll;
        return (d.items || []).filter(function (it) { return typeOk(f, it) && (!coll || !it.cs || it.cs.indexOf(coll) > -1); });
      });
    }
    function skeleton() { var h = ''; for (var i = 0; i < 8; i++) h += '<div class="fb-skel" aria-hidden="true"></div>'; el.grid.innerHTML = h; }
    function renderGrid(list, f) {
      items = list;
      var s = st.slots[st.active], chosen = s && s.pick ? s.pick.v : null;
      el.grid.innerHTML = list.map(function (it, i) {
        var src = it.i || '';
        return '<button type="button" class="fb-it" aria-pressed="' + (chosen === it.v ? 'true' : 'false') + '" data-i="' + i + '">' +
          '<span class="fb-it-ph">' + (src ? '<span class="fh-photo' + (it.k ? ' fh-cutout' : '') + '" data-fh-src="' + esc(src) + '"><img src="' + esc(src) + '" alt="" loading="lazy" decoding="async"></span>' : '') + '</span>' +
          '<span class="fb-it-c">' + icon('check') + '</span>' +
          '<span class="fb-it-t">' + esc(it.t) + '</span><span class="fb-it-p">' + esc(money(it.p)) + '</span></button>';
      }).join('');
    }
    function showFam(f) {
      var my = ++seq, q = (el.q.value || '').trim();
      el.msg.textContent = ''; el.more.hidden = true;
      if (f !== lastFam) { el.body.scrollTop = 0; lastFam = f; }
      if (q.length >= 2) {
        skeleton();
        search(f, q).then(function (list) {
          if (my !== seq) return;
          renderGrid(list, f);
          el.msg.textContent = list.length ? '' : (W.empty || 'No designs match that. Try another word.');
        }, function () { if (my !== seq) return; renderGrid([], f); errorMsg(f); });
        return;
      }
      var c = catalog(f);
      if (!c.items.length) skeleton();
      (c.items.length ? Promise.resolve(c) : loadPage(f)).then(function (c2) {
        if (my !== seq) return;
        renderGrid(c2.items.slice(), f);
        if (c2.err && !c2.items.length) errorMsg(f);
        else if (!c2.items.length) el.msg.textContent = W.empty || '';
        el.more.hidden = !(c2.page < c2.pages);
      });
    }
    function errorMsg(f) {
      el.msg.innerHTML = esc(W.error || 'Designs could not load.') + '<button type="button" data-fb-retry>' + esc(W.retry || 'Try again') + '</button>';
    }
    function renderSlots() {
      var html = st.slots.map(function (s, i) {
        var on = i === st.active, f = slotFam(s), p = s.pick;
        var label = p ? p.t : (s.fams.length > 1 ? s.fams.map(ctx.one).join(' / ') : ctx.one(f));
        return '<div class="fb-slot-w"><button type="button" class="fb-slot" aria-current="' + (on ? 'true' : 'false') + '" data-s="' + i + '" aria-label="' + esc((W.piece || 'Piece') + ' ' + (i + 1) + ': ' + label) + '">' +
          '<span class="fb-slot-img">' + (p && p.img ? '<img src="' + esc(p.img) + '" alt="">' : '<span class="fb-slot-ghost">' + icon(f) + '</span>') + '</span>' +
          '<span class="fb-slot-l">' + esc(label) + '</span></button>' +
          (p ? '<button type="button" class="fb-slot-x" data-x="' + i + '" aria-label="' + esc((W.remove || 'Remove') + ' ' + p.t) + '">' + icon('x') + '</button>' : '') + '</div>';
      }).join('');
      if (st.ladder && st.slots.length < 12) html += '<button type="button" class="fb-slot-add" data-add-slot>' + icon('plus') + esc(W.addPiece || 'Add another') + '</button>';
      el.slots.innerHTML = html;
      /* family switch for a slot that takes several kinds (e.g. tumbler, bottle or MagSafe) */
      var s = st.slots[st.active];
      if (s && s.fams.length > 1) {
        el.fams.hidden = false;
        el.fams.innerHTML = s.fams.map(function (f) { return '<button type="button" aria-pressed="' + (slotFam(s) === f ? 'true' : 'false') + '" data-fam="' + f + '">' + icon(f) + esc(ctx.one(f)) + '</button>'; }).join('');
      } else { el.fams.hidden = true; el.fams.innerHTML = ''; }
      renderVariant();
    }
    function renderVariant() {
      var s = st.slots[st.active], p = s && s.pick;
      if (!p || !p.vs || p.vs.length < 2) { el.variant.hidden = true; el.variant.innerHTML = ''; return; }
      el.variant.hidden = false;
      el.variant.innerHTML = '<span>' + esc(p.t) + '</span><select aria-label="' + esc(W.colour || 'Colour') + '">' + p.vs.map(function (x) {
        return '<option value="' + x[0] + '"' + (x[0] === p.vid ? ' selected' : '') + (x[2] ? '' : ' disabled') + '>' + esc(x[1]) + '</option>';
      }).join('') + '</select>';
    }
    function price() {
      var picked = st.slots.filter(function (s) { return s.pick; });
      /* every slot counts: picked pieces at their own price, empty ones at the standard price of their kind, so the
         total never jumps down when the first design is picked */
      var res = best(st.slots.map(function (s) { var f = slotFam(s); return { f: f, p: s.pick ? s.pick.p : cents(ctx.R.ref[f]) }; }));
      var need = st.slots.length - picked.length;
      el.total.textContent = money(res.total); el.was.hidden = !res.save; el.was.textContent = money(res.list);
      el.save.hidden = !res.save; el.save.textContent = (W.save || 'Save') + ' ' + money(res.save);
      el.nudge.textContent = '';
      if (st.ladder && picked.length && !need) {
        var f = st.ladder, unit = ctx.P && ctx.P.f === f && ctx.P.p ? ctx.P.p : cents(ctx.R.ref[f]), nxt = ctx.R.ladders.filter(function (L) { return L.fam === f && L.min > picked.length; }).sort(function (a, b) { return a.min - b.min; })[0];
        if (nxt) el.nudge.textContent = fill(W.nudge || 'Add [n] more to pay [price] each', { n: nxt.min - picked.length, price: money(unit - cents(nxt.off)) });
      }
      el.add.disabled = need > 0;
      el.add.textContent = need > 0 ? fill(W.pickMore || 'Pick [n] more', { n: need }) : fill(W.add || 'Add [n] to bag', { n: picked.length });
    }
    function setActive(i) {
      st.active = Math.max(0, Math.min(i, st.slots.length - 1));
      renderSlots(); showFam(slotFam(st.slots[st.active])); price();
      var b = $('[data-s="' + st.active + '"]', el.slots); if (b && b.scrollIntoView) b.scrollIntoView({ block: 'nearest', inline: 'nearest' });
    }
    function nextEmpty(from) {
      for (var i = 1; i <= st.slots.length; i++) { var k = (from + i) % st.slots.length; if (!st.slots[k].pick) return k; }
      return -1;
    }
    function pick(it) {
      var s = st.slots[st.active];
      if (st.ladder && s.pick && nextEmpty(st.active) < 0 && st.slots.length < 12) { st.slots.push({ fams: [st.ladder] }); s = st.slots[st.active = st.slots.length - 1]; }
      var img = it.i;
      if (it.vs) { var av = it.vs.filter(function (x) { return x[0] === it.v; })[0]; if (av && av[3]) img = av[3]; }
      s.pick = { v: it.v, vid: it.v, t: it.t, p: it.p, img: img, vs: it.vs || null, n: it.n };
      s.fam = s.fam || slotFam(s);
      var nx = nextEmpty(st.active);
      if (nx > -1 && !(it.vs && it.vs.length > 1)) setActive(nx);
      else { renderSlots(); price(); $$('.fb-it', el.grid).forEach(function (b) { b.setAttribute('aria-pressed', items[+b.getAttribute('data-i')] && items[+b.getAttribute('data-i')].v === it.v ? 'true' : 'false'); }); }
    }
    function open(card, from) {
      opener = from || null;
      var P = ctx.P;
      st = { card: card, ladder: card.ladder || null, active: 0, slots: card.slots.map(function (s) {
        var o = { fams: s.fams.slice(), fam: s.fam && s.fams.indexOf(s.fam) > -1 ? s.fam : null, pick: null };
        /* product page: this product is already in its slot */
        if (s.own && P) { o.fam = P.f; o.pick = { v: P.v, vid: P.v, t: P.t, p: P.p, img: P.i, vs: P.vs || null }; }
        return o;
      }) };
      el.title.textContent = card.title;
      el.sub.textContent = card.ladder ? card.steps.join('  ·  ') : card.sub;
      el.q.value = ''; lastFam = null;
      if (dlg.showModal) { dlg.showModal(); document.documentElement.classList.add('fb-lock'); }
      setActive(Math.max(0, nextEmpty(-1)));
      var first = $('.fb-slot[aria-current="true"]', el.slots) || $('.fb-slot', el.slots); if (first) first.focus({ preventScroll: true });
    }
    function close() { if (dlg.open) dlg.close(); }
    dlg.addEventListener('close', function () { document.documentElement.classList.remove('fb-lock'); if (opener && opener.focus) opener.focus({ preventScroll: true }); });
    function keepFocus(sel) {
      if (!dlg.open) return;
      var a = document.activeElement;
      if (a && a !== document.body && dlg.contains(a)) return;
      var t = (sel && $(sel, dlg)) || $('.fb-slot[aria-current="true"]', el.slots) || el.q;
      if (t) t.focus({ preventScroll: true });
    }
    dlg.addEventListener('click', function (e) {
      if (e.target === dlg) return close(); /* the backdrop */
      var fam = e.target.closest('[data-fam]');
      onClick(e);
      keepFocus(fam ? '[data-fam="' + fam.getAttribute('data-fam') + '"]' : null);
    });
    function onClick(e) {
      var t;
      if ((t = e.target.closest('[data-fb-s-close]'))) return close();
      if ((t = e.target.closest('[data-x]'))) { var i = +t.getAttribute('data-x'); st.slots[i].pick = null; if (st.ladder && st.slots.length > card0min()) st.slots.splice(i, 1); return setActive(Math.min(i, st.slots.length - 1)); }
      if ((t = e.target.closest('[data-s]'))) return setActive(+t.getAttribute('data-s'));
      if ((t = e.target.closest('[data-add-slot]'))) { st.slots.push({ fams: [st.ladder], fam: null, pick: null }); return setActive(st.slots.length - 1); }
      if ((t = e.target.closest('[data-fam]'))) { st.slots[st.active].fam = t.getAttribute('data-fam'); st.slots[st.active].pick = null; renderSlots(); showFam(slotFam(st.slots[st.active])); return price(); }
      if ((t = e.target.closest('.fb-it'))) { var it = items[+t.getAttribute('data-i')]; if (it) pick(it); return; }
      if ((t = e.target.closest('[data-fb-retry]'))) return showFam(slotFam(st.slots[st.active]));
      if ((t = e.target.closest('[data-fb-more]'))) { var f = slotFam(st.slots[st.active]); t.setAttribute('aria-busy', 'true'); loadPage(f).then(function () { t.removeAttribute('aria-busy'); showFam(f); }); return; }
      if ((t = e.target.closest('[data-fb-s-add]'))) return addAll(t);
    }
    function card0min() { return st.card.min || st.card.slots.length; }
    el.variant.addEventListener('change', function (e) {
      var s = st.slots[st.active], p = s && s.pick; if (!p || !p.vs) return;
      var v = +e.target.value, x = p.vs.filter(function (y) { return y[0] === v; })[0]; if (!x) return;
      p.vid = v; if (x[3]) p.img = x[3]; if (x[4]) p.p = x[4];
      renderSlots(); price();
    });
    el.q.addEventListener('input', function () { clearTimeout(qTimer); qTimer = setTimeout(function () { showFam(slotFam(st.slots[st.active])); }, 320); });
    el.q.addEventListener('keydown', function (e) { if (e.key === 'Enter') { e.preventDefault(); clearTimeout(qTimer); showFam(slotFam(st.slots[st.active])); } });
    function addAll(btn) {
      if (btn.disabled || btn.getAttribute('aria-busy') === 'true') return;
      var map = {}, order = [];
      st.slots.forEach(function (s) { if (!s.pick) return; var id = s.pick.vid; if (!map[id]) { map[id] = { id: id, quantity: 0 }; order.push(id); } map[id].quantity++; });
      var list = order.map(function (id) { return map[id]; });
      if (!list.length || !FH().addItems) return;
      btn.setAttribute('aria-busy', 'true');
      var img = st.slots[0].pick && st.slots[0].pick.img;
      FH().addItems(list).then(function () {
        btn.removeAttribute('aria-busy'); close();
        var cfg = (FH().config && FH().config.routes) || {};
        if (FH().toast) FH().toast(W.added || 'Bundle added to your bag', img, { link: cfg.cart || '/cart', linkText: W.viewBag || 'View bag' });
      }).catch(function (err) {
        btn.removeAttribute('aria-busy');
        if (FH().toast) FH().toast((err && err.message) || W.addError || 'Could not add to bag', null, { error: true });
      });
    }
    return { open: open, close: close };
  }

  /* ================================================================== Countries builder */
  function initCountries(ctx) {
    var cb = $('[data-fb-cb]', ctx.sec); if (!cb) return;
    var raw = parse($('script[data-fh-countries]', ctx.sec), null), empty = $('[data-fb-cb-empty]', ctx.sec);
    var W = {}; ['full', 'pickmore', 'add', 'add1', 'empty', 'missing', 'showall', 'showless', 'nomatch', 'nudge', 'nudgemug', 'nudgetum', 'nudgecountry', 'top', 'none', 'added', 'shelf', 'mug', 'tumbler'].forEach(function (k) { W[k] = cb.getAttribute('data-w-' + k) || ''; });
    var C = {}, names = [];
    if (raw && raw.products) raw.products.forEach(function (p) {
      if (!p.n) return;
      var t = p.t === 'tumbler' ? 'tumbler' : 'mug', c = C[p.n];
      if (!c) { c = C[p.n] = { n: p.n }; names.push(p.n); }
      if (!c[t]) c[t] = { id: p.id, p: p.p, img: p.k === 1 ? p.i : (raw.base || '') + p.i, k: p.k === 1 };
    });
    names.sort(function (a, b) { return a.localeCompare(b); });
    if (!names.length) { cb.hidden = true; if (empty) empty.hidden = false; return; }
    var el = {
      fmts: $$('.fb-fmt', cb), hint: $('[data-fb-hint]', cb), type: $('[data-fb-type]', cb), q: $('[data-fb-q]', cb), list: $('[data-fb-countries]', cb), all: $('[data-fb-showall]', cb),
      shelf: $('[data-fb-cshelf]', cb), shelfEmpty: $('[data-fb-cshelf-empty]', cb), picks: $('[data-fb-picks]', cb), count: $('[data-fb-count-picked]', cb),
      list$: $('[data-fb-list]', cb), rule: $('[data-fb-rule]', cb), save: $('[data-fb-save]', cb), nudge: $('[data-fb-nudge]', cb), total: $('[data-fb-total]', cb), was: $('[data-fb-was]', cb), add: $('[data-fb-add]', cb), bar: $('[data-fb-bar]', cb)
    };
    ['placeholder', 'aria-label'].forEach(function (a) { var v = el.q.getAttribute(a); if (v) el.q.setAttribute(a, fill(v, { n: names.length })); });
    var featured = (cb.getAttribute('data-featured') || '').split(',').map(function (s) { return s.trim(); }).filter(function (n) { return C[n]; });
    if (!featured.length) featured = names.slice(0, 8);
    var def = cb.getAttribute('data-default'); def = C[def] ? def : featured[0];
    var st = { fmt: null, max: 1, per: 'mug+tumbler', picks: [], type: 'mug', all: false };

    function itemsOf(picks, per) {
      var out = [];
      picks.forEach(function (pk) {
        var c = C[pk.n]; if (!c) return;
        var types = per === 'custom' ? [pk.t] : per === 'mug+tumbler' ? ['mug', 'tumbler'] : [per];
        types.forEach(function (t) { if (c[t]) out.push({ f: t, p: c[t].p, id: c[t].id, n: pk.n, img: c[t].img, k: c[t].k }); });
      });
      return out;
    }
    function fmtIcons(per, max) {
      if (per === 'custom') return icon('mug') + icon('tumbler') + '<i>+</i>';
      var one = per === 'mug+tumbler' ? icon('mug') + icon('tumbler') : icon(per === 'tumbler' ? 'tumbler' : 'mug');
      if (max === 1) return one;
      if (per === 'mug+tumbler') return one + '<i>× ' + max + '</i>';
      return max <= 3 ? Array(max + 1).join(one) : one + one + one + '<i>× ' + max + '</i>';
    }
    /* each format card shows the price you would pay with the default country (or the first ones in the list) */
    el.fmts.forEach(function (b) {
      var max = parseInt(b.getAttribute('data-max'), 10) || 1, per = b.getAttribute('data-per') || 'mug';
      $('.fb-fmt-ics', b).innerHTML = fmtIcons(per, max);
      var pb = $('[data-fb-fmtprice]', b);
      if (per === 'custom') { pb.textContent = ''; return; }
      var sample = [def].concat(featured.filter(function (n) { return n !== def; })).concat(names).slice(0, max).map(function (n) { return { n: n }; });
      var res = best(itemsOf(sample, per));
      pb.innerHTML = '<span>' + esc(money(res.total)) + '</span>' + (res.save ? '<em>−' + esc(money(res.save)) + '</em>' : '');
    });

    function chip(n) {
      var c = C[n], t = st.per === 'tumbler' || (st.per === 'custom' && st.type === 'tumbler') ? 'tumbler' : 'mug', ph = c[t] || c.mug || c.tumbler;
      var cnt = st.picks.filter(function (p) { return p.n === n; }).length;
      return '<button type="button" class="fb-c" aria-pressed="' + (cnt ? 'true' : 'false') + '" data-n="' + esc(n) + '">' +
        '<span class="fb-c-ph">' + (ph ? '<span class="fh-photo' + (ph.k ? ' fh-cutout' : '') + '" data-fh-src="' + esc(ph.img) + '"><img src="' + esc(ph.img) + '" alt="" loading="lazy" decoding="async"></span>' : '') + '</span>' +
        '<span class="fb-c-n">' + esc(n) + '</span><span class="fb-c-b" aria-hidden="true">' + (cnt > 1 ? cnt : icon('check')) + '</span></button>';
    }
    function renderList() {
      var q = (el.q.value || '').trim().toLowerCase(), list;
      if (q) {
        var starts = names.filter(function (n) { return n.toLowerCase().indexOf(q) === 0; }), inc = names.filter(function (n) { var l = n.toLowerCase(); return l.indexOf(q) > 0; });
        list = starts.concat(inc);
        el.all.hidden = true;
      } else {
        var pickedNames = st.picks.map(function (p) { return p.n; });
        list = st.all ? names : featured.concat(pickedNames.filter(function (n, i) { return featured.indexOf(n) < 0 && pickedNames.indexOf(n) === i; }));
        el.all.hidden = false;
        el.all.textContent = st.all ? (W.showless || 'Show fewer') : fill(W.showall || 'Show all [n] countries', { n: names.length });
      }
      var key = list.join('|') + '#' + st.per + st.type;
      if (key === lastKey && list.length) return syncChips();
      lastKey = key;
      el.list.innerHTML = list.length ? list.map(chip).join('') : '<p class="fb-cb-msg">' + esc(W.nomatch) + '</p>';
    }
    var lastKey = '';
    function syncChips() {
      $$('.fb-c', el.list).forEach(function (b) {
        var n = b.getAttribute('data-n'), cnt = st.picks.filter(function (p) { return p.n === n; }).length, badge = $('.fb-c-b', b);
        b.setAttribute('aria-pressed', cnt ? 'true' : 'false');
        if (badge) badge.innerHTML = cnt > 1 ? String(cnt) : icon('check');
      });
    }
    function hint(txt, warn) { el.hint.textContent = txt || ''; el.hint.classList.toggle('fb-warn', !!warn); }
    function update() {
      var items = itemsOf(st.picks, st.per), res = best(items);
      /* shelf: every piece at true relative height, all shrinking together when the row is full */
      var html = '';
      if (items.length) {
        var max = 0; items.forEach(function (it) { max = Math.max(max, CM[it.f]); });
        html = '<div class="fb-crow">' + items.slice(0, 24).map(function (it) {
          var k = (CM[it.f] / max * (max < 15 ? 0.62 : 0.94)).toFixed(3);
          return '<span class="fb-ci" style="--k:' + k + '"><span class="fh-photo' + (it.k ? ' fh-cutout' : '') + '" data-fh-src="' + esc(it.img) + '"><img src="' + esc(it.img) + '" alt="' + esc(it.n + ' ' + (it.f === 'tumbler' ? W.tumbler : W.mug)) + '" decoding="async"></span></span>';
        }).join('') + '</div>';
      }
      $$('.fb-crow', el.shelf).forEach(function (r) { r.remove(); });
      el.shelf.insertAdjacentHTML('beforeend', html);
      el.shelfEmpty.hidden = !!items.length;
      el.picks.innerHTML = st.picks.map(function (pk, i) {
        var what = st.per === 'custom' ? (pk.t === 'tumbler' ? W.tumbler : W.mug) : st.per === 'mug+tumbler' ? W.mug + ' + ' + W.tumbler : st.per === 'tumbler' ? W.tumbler : W.mug;
        return '<li><button type="button" data-rm="' + i + '" aria-label="' + esc((ctx.W.remove || 'Remove') + ' ' + pk.n + ' ' + what) + '">' + esc(pk.n) + ' · ' + esc(what) + icon('x') + '</button></li>';
      }).join('');
      var fixed = st.per !== 'custom', need = fixed ? st.max - st.picks.length : Math.max(0, 1 - items.length);
      el.count.textContent = fixed ? st.picks.length + ' / ' + st.max : (items.length ? String(items.length) : '');
      el.list$.textContent = money(items.length ? res.list : 0);
      el.rule.textContent = res.save ? ruleName(res) : (W.none || 'No saving yet');
      el.save.textContent = res.save ? '−' + money(res.save) : money(0);
      el.total.textContent = money(items.length ? res.total : 0);
      el.was.hidden = !res.save; el.was.textContent = money(res.list);
      el.nudge.textContent = nudge(items, res, need);
      var missing = st.picks.some(function (pk) { var c = C[pk.n]; var ts = st.per === 'custom' ? [pk.t] : st.per === 'mug+tumbler' ? ['mug', 'tumbler'] : [st.per]; return ts.some(function (t) { return !c || !c[t]; }); });
      if (!items.length) { el.add.disabled = true; el.add.textContent = W.empty; }
      else if (need > 0) { el.add.disabled = true; el.add.textContent = fill(W.pickmore, { n: need }); }
      else if (missing) { el.add.disabled = true; el.add.textContent = W.missing; }
      else { el.add.disabled = false; el.add.textContent = fill(items.length === 1 && W.add1 ? W.add1 : W.add, { n: items.length }); }
      renderList();
    }
    function ruleName(res) {
      var r = res.rule || {};
      if (res.kind === 'ladder') return r.min + '+ ' + lc(ctx.many(r.fam) || '');
      if (res.kind === 'pair') return pairTitle(ctx, r.buy, r.get);
      return r.name || ctx.F.set || '';
    }
    function nudge(items, res, need) {
      if (st.per !== 'custom') {
        if (need > 0) { var full = best(itemsOf(st.picks.concat(Array.apply(null, Array(need)).map(function () { return { n: st.picks.length ? st.picks[0].n : def }; })), st.per)); return full.save > res.save ? fill(W.pickmore, { n: need }) + ' · −' + money(full.save) : ''; }
        return res.save ? fill(W.top, { amount: money(res.save) }) : '';
      }
      var last = st.picks.length ? st.picks[st.picks.length - 1].n : def, gain = 0, what = '';
      ['mug', 'tumbler'].forEach(function (t) { if (!C[last][t]) return; var r2 = best(itemsOf(st.picks.concat([{ n: last, t: t }]), 'custom')); if (r2.save - res.save > gain) { gain = r2.save - res.save; what = t === 'mug' ? W.nudgemug : W.nudgetum; } });
      return gain > 0 ? fill(W.nudge, { item: what, amount: money(gain) }) : (res.save ? fill(W.top, { amount: money(res.save) }) : '');
    }
    function setFmt(b, keep) {
      el.fmts.forEach(function (x) { x.setAttribute('aria-checked', x === b ? 'true' : 'false'); x.tabIndex = x === b ? 0 : -1; });
      st.fmt = b; st.max = parseInt(b.getAttribute('data-max'), 10) || 1; st.per = b.getAttribute('data-per') || 'mug';
      el.type.hidden = st.per !== 'custom';
      if (st.per === 'custom') { if (!keep) st.picks = st.picks.map(function (p) { return { n: p.n, t: p.t || st.type }; }); }
      else { var seen = {}; st.picks = st.picks.filter(function (p) { if (seen[p.n]) return false; seen[p.n] = 1; return true; }).slice(0, st.max).map(function (p) { return { n: p.n }; }); }
      hint(b.getAttribute('data-hint'));
      update();
    }
    function toggle(n) {
      if (st.per === 'custom') {
        var i = -1; st.picks.forEach(function (p, k) { if (p.n === n && p.t === st.type) i = k; });
        if (i > -1) st.picks.splice(i, 1); else if (st.picks.length < 24) st.picks.push({ n: n, t: st.type });
        return update();
      }
      var j = -1; st.picks.forEach(function (p, k) { if (p.n === n) j = k; });
      if (j > -1) { st.picks.splice(j, 1); hint(st.fmt.getAttribute('data-hint')); return update(); }
      if (st.picks.length >= st.max) {
        if (st.max === 1) { st.picks = [{ n: n }]; return update(); }
        hint(fill(W.full, { n: st.max }), true);
        if (!reduce) { el.picks.classList.remove('fb-shake'); void el.picks.offsetWidth; el.picks.classList.add('fb-shake'); }
        return;
      }
      st.picks.push({ n: n });
      update();
    }
    cb.addEventListener('click', function (e) {
      var chipN = e.target.closest('.fb-c'), rm = e.target.closest('[data-rm]');
      chipN = chipN && chipN.getAttribute('data-n'); rm = rm ? +rm.getAttribute('data-rm') : -1;
      onCb(e);
      var a = document.activeElement;
      if (a && a !== document.body && cb.contains(a)) return;
      var t = null;
      if (chipN) t = $$('.fb-c', el.list).filter(function (b) { return b.getAttribute('data-n') === chipN; })[0];
      if (!t && rm > -1) { var r = $$('[data-rm]', el.picks); t = r[Math.min(rm, r.length - 1)] || el.q; }
      if (t) t.focus({ preventScroll: true });
    });
    function onCb(e) {
      var t;
      if ((t = e.target.closest('[data-fb-fmore]'))) {
        /* "More bundle sizes": show the rest of the formats */
        var open = t.getAttribute('aria-expanded') !== 'true';
        $$('.fb-fmt--more', cb).forEach(function (x) { x.hidden = !open; });
        t.setAttribute('aria-expanded', open ? 'true' : 'false');
        t.textContent = open ? (t.getAttribute('data-less') || 'Fewer sizes') : (t.getAttribute('data-more') || 'More bundle sizes');
        if (!open && st.fmt && st.fmt.hidden) setFmt(el.fmts[0]);
        return;
      }
      if ((t = e.target.closest('.fb-fmt'))) return setFmt(t);
      if ((t = e.target.closest('.fb-c'))) return toggle(t.getAttribute('data-n'));
      if ((t = e.target.closest('[data-rm]'))) { st.picks.splice(+t.getAttribute('data-rm'), 1); hint(st.fmt.getAttribute('data-hint')); return update(); }
      if ((t = e.target.closest('[data-t]'))) { st.type = t.getAttribute('data-t'); $$('[data-t]', el.type).forEach(function (x) { x.setAttribute('aria-pressed', x === t ? 'true' : 'false'); }); return renderList(); }
      if ((t = e.target.closest('[data-fb-showall]'))) { st.all = !st.all; renderList(); if (!st.all) el.q.scrollIntoView({ block: 'nearest', behavior: reduce ? 'auto' : 'smooth' }); return; }
      if ((t = e.target.closest('[data-fb-add]'))) return add(t);
    }
    cb.addEventListener('keydown', function (e) {
      var b = e.target.closest('.fb-fmt'); if (!b) return;
      var d = e.key === 'ArrowRight' || e.key === 'ArrowDown' ? 1 : e.key === 'ArrowLeft' || e.key === 'ArrowUp' ? -1 : 0; if (!d) return;
      e.preventDefault(); var vis = el.fmts.filter(function (x) { return !x.hidden; }), i = vis.indexOf(b), nb = vis[(i + d + vis.length) % vis.length]; setFmt(nb); nb.focus();
    });
    var qt; el.q.addEventListener('input', function () { clearTimeout(qt); qt = setTimeout(renderList, 120); });
    function add(btn) {
      if (btn.disabled || btn.getAttribute('aria-busy') === 'true' || !FH().addItems) return;
      var items = itemsOf(st.picks, st.per), map = {}, order = [];
      items.forEach(function (it) { if (!map[it.id]) { map[it.id] = { id: it.id, quantity: 0 }; order.push(it.id); } map[it.id].quantity++; });
      btn.setAttribute('aria-busy', 'true');
      FH().addItems(order.map(function (id) { return map[id]; })).then(function () {
        btn.removeAttribute('aria-busy');
        var cfg = (FH().config && FH().config.routes) || {};
        if (FH().toast) FH().toast(W.added, items[0] && items[0].img, { link: cfg.cart || '/cart', linkText: (ctx.W.viewBag || 'View bag') });
      }).catch(function (err) { btn.removeAttribute('aria-busy'); if (FH().toast) FH().toast((err && err.message) || ctx.W.addError || 'Could not add to bag', null, { error: true }); });
    }
    /* phones: dock the price and button to the bottom of the screen while the builder is on screen */
    var mq = window.matchMedia ? matchMedia('(max-width: 899px)') : null, toolbar = document.querySelector('.halo-toolbar-mobile, .toolbar-mobile, .halo-toolbar');
    function offset() {
      var h = 0;
      if (toolbar && getComputedStyle(toolbar).display !== 'none' && toolbar.offsetHeight) { var r = toolbar.getBoundingClientRect(); if (r.bottom > innerHeight - 4) h = r.height; }
      cb.style.setProperty('--fb-toolbar', h + 'px');
    }
    if ('IntersectionObserver' in window && mq) {
      var io = new IntersectionObserver(function (es) {
        es.forEach(function (en) {
          var on = en.isIntersecting && mq.matches && en.intersectionRect.height > 140;
          if (on) offset();
          cb.classList.toggle('fb-cb--dock', on);
          document.documentElement.classList.toggle('fb-hide-mbar', on);
        });
      }, { threshold: [0, 0.05, 0.1, 0.2] });
      io.observe(cb);
    }
    /* start with the first format and the default country, so a price and a full shelf show straight away */
    if (el.fmts[0]) { st.picks = [{ n: def, t: 'mug' }]; setFmt(el.fmts[0], true); }
    /* links to #build from the featured card scroll here; nothing else to do */
  }

  /* ================================================================== buy-box savings strip (product page) */
  function initOffer(ctx) {
    var R = ctx.R;
    $$('[data-fb-offer]').forEach(function (box) {
      if (box.__fbOffer) return;
      var f = box.getAttribute('data-fam'), steps = (R.ladders || []).filter(function (L) { return L.fam === f; }).sort(function (a, b) { return a.min - b.min; });
      if (!steps.length) { box.hidden = true; return; }
      box.__fbOffer = true;
      var W = {}; ['title', 'nudge', 'top', 'link', 'save', 'atc', 'note'].forEach(function (k) { W[k] = box.getAttribute('data-w-' + k) || ''; });
      var base = parseInt(box.getAttribute('data-price'), 10) || cents(R.ref && R.ref[f]);
      var qty = document.getElementById(box.getAttribute('data-qty') || ''), many = lc(ctx.many(f));
      var anchor = box.getAttribute('data-anchor'), target = anchor && document.getElementById(anchor);
      var bestPair = 0;
      if (target && !target.hidden && ctx.cards) ['pairs', 'sets'].forEach(function (t) { (ctx.cards[t] || []).forEach(function (c) { bestPair = Math.max(bestPair, c.save); }); });
      var link = bestPair ? '<a class="fb-offer-link" href="#' + esc(anchor) + '">' + esc(fill(W.link || 'Pairs & sets', { amount: money(bestPair) })) + icon('arrow') + '</a>' : '';
      var tiers = [{ min: 1, off: 0 }].concat(steps.map(function (L) { return { min: L.min, off: cents(L.off) }; }));
      function unit() { var v = qty && parseInt(qty.getAttribute('data-price'), 10); return v > 0 ? v : base; }
      /* the buy button says what this quantity costs after the saving, so it matches the "You save" line above it */
      var scope = (qty && qty.closest('form, .productView-details, .productView, product-info')) || document;
      var btn = scope.querySelector('#product-add-to-cart, [data-btn-addtocart]') || document.getElementById('product-add-to-cart'), mine = '';
      function syncBtn(total) {
        if (!btn || btn.disabled) return;
        var cur = btn.textContent.trim();
        if (cur === mine || !/\d/.test(cur) || !/add/i.test(cur)) return;
        mine = fill(W.atc || 'Add to bag · [price]', { price: money(total) });
        btn.textContent = mine;
      }
      if (btn && window.MutationObserver) new MutationObserver(function () { if (btn.textContent.trim() !== mine) { mine = ''; render(); } }).observe(btn, { childList: true, characterData: true, subtree: true });
      function count() { var n = qty ? parseInt(qty.value, 10) : 1; return n > 0 ? n : 1; }
      function render() {
        var u = unit(), n = count(), cur = tiers[0], nxt = null;
        tiers.forEach(function (t) { if (n >= t.min) cur = t; else if (!nxt) nxt = t; });
        var title = W.title || 'Buy more, pay less';
        box.innerHTML = '<div class="fb-offer-head"><b>' + esc(title) + '</b>' + link + '</div>' +
          '<div class="fb-tiers" role="group" aria-label="' + esc(title) + '">' + tiers.map(function (t) {
            var on = t === cur;
            return '<button type="button" class="fb-tier' + (on ? ' fb-on' : '') + '" data-q="' + t.min + '" aria-pressed="' + (on ? 'true' : 'false') + '"><b>' + t.min + (t.min > 1 ? '+' : '') + '</b><span>' + esc(money(u - t.off)) + '</span></button>';
          }).join('') + '</div>' +
          '<p class="fb-offer-line" aria-live="polite">' + (cur.off ? '<span class="fb-save-pill">' + esc((W.save || 'You save') + ' ' + money(cur.off * n)) + '</span>' : '') +
          '<span>' + esc(nxt ? fill(W.nudge || 'Add [n] more (any design) to pay [price] each', { n: nxt.min - n, price: money(u - nxt.off), fam: many }) : fill(W.top || 'Best price reached: [price] each', { price: money(u - cur.off) })) + '</span></p>' +
          (W.note ? '<p class="fb-offer-note">' + icon('check') + '<span>' + esc(W.note) + '</span></p>' : '');
        syncBtn((u - cur.off) * n);
      }
      render(); box.hidden = false;
      box.addEventListener('click', function (e) {
        var b = e.target.closest('[data-q]'); if (!b || !qty) return;
        var q = b.getAttribute('data-q');
        qty.value = q;
        qty.dispatchEvent(new Event('input', { bubbles: true })); qty.dispatchEvent(new Event('change', { bubbles: true }));
        render();
        var nb = $('[data-q="' + q + '"]', box); if (nb) nb.focus({ preventScroll: true });
      });
      if (qty) {
        ['input', 'change'].forEach(function (ev) { qty.addEventListener(ev, render); });
        var grp = qty.closest('quantity-input') || qty.parentElement;
        if (grp) grp.addEventListener('click', function () { setTimeout(render, 40); });
      }
      /* a variant with its own price: re-read the unit price once the theme has updated it */
      document.addEventListener('change', function (e) { var t = e.target; if (t && t.closest && t.closest('variant-radios, variant-selects, .productView-options, .productView-variants')) setTimeout(render, 120); });
    });
  }

  function all() { $$('.fh-bundles[data-fh-fams]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', all); else all();
  document.addEventListener('shopify:section:load', function (e) { var s = e.target && e.target.querySelector && e.target.querySelector('.fh-bundles'); if (s) init(s); });
})();
